const COMMON_EMAIL_DOMAINS = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'aol.com',
    'live.com',
    'msn.com'
];

function isOneEditAway(value, candidate) {
    const lengthDifference = Math.abs(value.length - candidate.length);

    if (lengthDifference > 1 || value === candidate) {
        return false;
    }

    if (value.length === candidate.length) {
        const differences = [];

        for (let index = 0; index < value.length; index += 1) {
            if (value[index] !== candidate[index]) {
                differences.push(index);
            }
        }

        return (
            differences.length === 1 ||
            (differences.length === 2 &&
                differences[1] === differences[0] + 1 &&
                value[differences[0]] === candidate[differences[1]] &&
                value[differences[1]] === candidate[differences[0]])
        );
    }

    const [shorter, longer] =
        value.length < candidate.length
            ? [value, candidate]
            : [candidate, value];
    let shorterIndex = 0;
    let longerIndex = 0;
    let skipped = false;

    while (shorterIndex < shorter.length && longerIndex < longer.length) {
        if (shorter[shorterIndex] === longer[longerIndex]) {
            shorterIndex += 1;
            longerIndex += 1;
            continue;
        }

        if (skipped) {
            return false;
        }

        skipped = true;
        longerIndex += 1;
    }

    return true;
}

export function suggestCommonEmailDomain(email) {
    const normalized = String(email ?? '').trim();
    const separator = normalized.lastIndexOf('@');

    if (
        separator <= 0 ||
        separator !== normalized.indexOf('@') ||
        separator === normalized.length - 1
    ) {
        return null;
    }

    const localPart = normalized.slice(0, separator);
    const domain = normalized.slice(separator + 1).toLowerCase();

    if (COMMON_EMAIL_DOMAINS.includes(domain)) {
        return null;
    }

    const suggestedDomain = COMMON_EMAIL_DOMAINS.find((candidate) =>
        isOneEditAway(domain, candidate)
    );

    return suggestedDomain ? `${localPart}@${suggestedDomain}` : null;
}

function updateSuggestion(input) {
    const field = input.closest('.form-field');
    const message =
        field?.querySelector('[data-email-domain-suggestion-message]') ??
        (field?.nextElementSibling?.matches(
            '[data-email-domain-suggestion-message]'
        )
            ? field.nextElementSibling
            : null);
    const applyButton = message?.querySelector(
        '[data-email-domain-suggestion-apply]'
    );
    const suggestion = suggestCommonEmailDomain(input.value);

    if (!message || !applyButton) {
        return;
    }

    message.hidden = !suggestion;
    applyButton.textContent = suggestion ?? '';
    applyButton.dataset.emailDomainSuggestionValue = suggestion ?? '';
}

export function refreshEmailDomainSuggestions(root = document) {
    if (root?.matches?.('[data-email-domain-suggestion]')) {
        updateSuggestion(root);
    }

    root?.querySelectorAll?.('[data-email-domain-suggestion]').forEach(
        updateSuggestion
    );
}

let initialized = false;

export function initEmailDomainSuggestions() {
    if (initialized) {
        return;
    }

    initialized = true;
    refreshEmailDomainSuggestions();

    document.addEventListener('input', (event) => {
        if (event.target?.matches?.('[data-email-domain-suggestion]')) {
            updateSuggestion(event.target);
        }
    });

    document.addEventListener('focusout', (event) => {
        if (event.target?.matches?.('[data-email-domain-suggestion]')) {
            updateSuggestion(event.target);
        }
    });

    document.addEventListener('htmx:afterSwap', (event) => {
        refreshEmailDomainSuggestions(event.detail?.target ?? document);
    });

    document.addEventListener('click', (event) => {
        const applyButton = event.target?.closest?.(
            '[data-email-domain-suggestion-apply]'
        );
        const suggestion = applyButton?.dataset.emailDomainSuggestionValue;
        const message = applyButton?.closest(
            '[data-email-domain-suggestion-message]'
        );
        const input =
            message
                ?.closest('.form-field')
                ?.querySelector('[data-email-domain-suggestion]') ??
            message?.previousElementSibling?.querySelector(
                '[data-email-domain-suggestion]'
            );

        if (!suggestion || !input) {
            return;
        }

        input.value = suggestion;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.focus();
    });
}
